<template>
  <div class="l-container confirm-info mx-auto">
    <div class="top-title ml-2">
      <h3>ロープライス・ギャランティー申請 完了</h3>
    </div>
    <div class="mt-6 mb-6 divider"></div>
    <div class="main-content">
      <div class="c-box m-4">
        <div class="text-center title-cancel">
          <span class="font-blod">申請完了しました。</span>
        </div>
        <div class="content-cancel">
          <span>ロープライス・ギャランティーの適用可否は、後日、カスタマーセンターからメールか電話にてご連絡いたしますので、しばらくお待ち下さい。</span>
        </div>
        <div class="py-6 w-full text-center">
          <button class="c-btn bg-gray-200">
            <span style="font-size:16px" class="px-16 font-bold sm:px-1" @click="handleNext">ベネフィット・ステーション トップへ</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BS_APP_03_003',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    handleNext() {
      this.$router.push({path: 'bs-top-01-001'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>